
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorChatActivo } from '../../controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import { Cliente } from '@/__env/lib/Clientes';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Controlador as ControladorPrincipal } from '../../../controlador';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorChatActivo;
        public get Chat() { return this.Controlador.Chat; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.ReservarEspacioDerecha.Espacio; }
        public get ControladorBarras() { return this.Controlador.ControladorBarrasLaterales; }
        public get Modo() { return this.ControladorBarras.Vista.Modo; }
        public set Modo( x: string ) { this.ControladorBarras.Vista.Modo = x; }
        public get SubModo() { return this.ControladorBarras.Vista.SubModo; }
        public set SubModo( x: string ) { this.ControladorBarras.Vista.SubModo = x; }

        public Cargando: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async   mounted()
        {
            this.Eventos.push( this.ControladorBarras.Vista.onSubModo.subscribe( () =>
            {
                if ( this.SubModo == 'facturas' )
                {
                    this.Controlador.Vista.ReservarEspacioDerecha.Espacio = 500;
                }
            } ) );

            this.SubModo = 'facturas';
            this.Iniciar();
        }


        Estado: 'ok' | 'cargando' | 'error' = 'cargando';
        public Cliente: Cliente = new Cliente();
        public HayCambios: boolean = false;


        async Iniciar()
        {
            this.Estado = 'cargando';

            await Wait( 100 );
            this.Cliente = await Cliente.create( this.Chat.Cliente.Id );

            this.Estado = 'ok';
            this.HayCambios = false;

            this.$nextTick( () =>
            {
                document.getElementById( 'primer-input' ).getElementsByTagName( 'input' )[0].focus();
            } );
        }

        async Guardar()
        {
            this.Estado = 'cargando';
            let e = await this.Cliente.save();
            if ( e )
            {
                this.Estado = 'ok';
                this.Chat.Cliente = this.Cliente;
                this.Cerrar();
                this.$EventBus.Notificaciones.Completado( 'Guardado correctamente' );

            }
            else
            {
                this.Estado = 'ok';
                this.$EventBus.Notificaciones.Error( 'Error al guardar' );
            }
        }

        Cerrar()
        {
            this.Modo = 'menu';
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
